import { ReactNode } from 'react';
import styled from 'styled-components';
import { Icon, IconName, IconSize } from '@ardoq/icons';
import { colors, spacing } from '@ardoq/design-tokens';
import { InlineText, text2 } from '@ardoq/typography';
import { ModalListOption } from '../types';

const ModalListItemStyle = styled.li`
  list-style: none;
  min-height: ${spacing.s24};
  display: flex;
  align-items: center;

  i:first-child,
  svg:first-child {
    margin-right: 8px;
    color: ${colors.icon};
    flex-shrink: 0;
  }
`;

const ModalListWrapperStyle = styled.ul`
  margin: 0;
  padding: 0;
  ${text2}

  ${ModalListItemStyle} {
    line-height: 20px;
    margin-bottom: ${spacing.s4};
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export interface ModalListWrapperProps {
  children?: ReactNode;
}

export const ModalListItemStrong = ({ children }: ModalListWrapperProps) => (
  <InlineText variant="text2Bold">{children}</InlineText>
);

export const ModalListItem = ({
  children,
  iconName,
  iconColor,
}: ModalListWrapperProps & { iconName?: IconName; iconColor?: string }) => (
  <ModalListItemStyle>
    <Icon
      iconName={iconName || IconName.ARROW_FORWARD}
      iconSize={IconSize.LARGE}
      color={iconColor}
    />
    <div>{children}</div>
  </ModalListItemStyle>
);

export const ModalListWrapper = ({ children }: ModalListWrapperProps) => (
  <ModalListWrapperStyle>{children}</ModalListWrapperStyle>
);

export type ModalListProps = {
  options?: ModalListOption[];
};

export const ModalList = ({ options = [] }: ModalListProps) =>
  options.length ? (
    <ModalListWrapper>
      {options.map((option, index) => (
        <ModalListItem key={index} iconName={option.iconName}>
          {option.strongText && (
            <ModalListItemStrong>{option.strongText}</ModalListItemStrong>
          )}{' '}
          {option.text}
        </ModalListItem>
      ))}
    </ModalListWrapper>
  ) : null;
